export default "/_next/static/chunks/fonts/proximanova-regular-webfont-942d3edb2d3c85a55e931c63f448d0da.woff";